import { action } from '@storybook/addon-actions';
import {
	Component,
	Input,
	ContentChildren,
	ViewEncapsulation,
	forwardRef,
	OnDestroy, Output, EventEmitter
} from "@angular/core";

import { ExpandableComponent } from "../expandable/expandable.component";
import { IdService } from "../shared/services/id.service";

@Component({
	selector: "rbc-expandable-container",
	templateUrl: "./expandable-container.component.html",
	encapsulation: ViewEncapsulation.None,
	styles: []
})
export class ExpandableContainerComponent implements OnDestroy {
	activeItem = {
		id: null,
		all: false
	};

	@Input() id: string;
	@Input() accordion = false;
	@Input() card = true;
	@Input() title: string;
	@Input() showButton = true;
	@Input() buttonOpenAll = "Expand all";
	@Input() buttonCloseAll = "Collapse all";
	@Input() ariaControls;

	@ContentChildren(forwardRef(() => ExpandableComponent)) expandables;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	get buttonText() {
		return this.isAllExpanded() ? this.buttonCloseAll : this.buttonOpenAll;
	}

	toggleExpanded() {
		const action = !this.isAllExpanded();

		for (const expandable of this.expandables._results) {
			expandable.expanded = action;
		}
	}

	isAllExpanded() {
		for (const expandable of this.expandables._results) {
			if (!expandable.expanded) {
				return false;
			}
		}

		return true;
	}

	childExpanded(id: string, expanded: boolean) {
		if (!this.accordion) {
			return;
		}
		for (const expandable of this.expandables._results) {
			if (expandable.id === id) {
				expandable.expanded = expanded;
			} else {
				expandable.expanded = false;
			}
		}
	}
}
